import React, { MouseEvent } from 'react';
import classNames from 'classnames';

interface IField {
  selected: boolean;
  dark: boolean;
  highlight: any;
  color: any;
  moved: boolean;
  fieldRef: any;
  onMouseDown: (e: MouseEvent<HTMLDivElement>) => void;
  onMouseUp: (e: MouseEvent<HTMLDivElement>) => void;
  onMouseMove: (e: MouseEvent<HTMLDivElement>) => void;
  onContextMenu: (e: MouseEvent<HTMLDivElement>) => void;
  id: string;
  number: number | null;
  children: React.ReactNode;
}

const Field: React.FC<IField> = ({
  selected,
  dark,
  highlight,
  color,
  moved,
  fieldRef,
  onMouseDown,
  onMouseUp,
  onMouseMove,
  onContextMenu,
  id,
  number,
  children,
}) => {
  return (
    <div
      className={classNames('field', {
        selected: selected,
        dark: dark,
        [highlight]: !!highlight,
        color: !!color,
        [color]: !!color,
        moved: moved,
      })}
      ref={fieldRef}
      onMouseDown={onMouseDown}
      onMouseUp={onMouseUp}
      onMouseMove={onMouseMove}
      onContextMenu={onContextMenu}
      id={id}
    >
      <span>{number}</span>
      {children}
    </div>
  );
};

export default Field;
